import {useEffect, useState} from 'react';
import {UIModel} from '../../models/UIModel.js';
import {Object3D} from '@wonderlandengine/api';
import {useTextState} from './useTextState.js';

export function useDailyTimer(): [boolean, string, React.RefObject<Object3D>] {
    const [showDailyRewardTimer, setShowDailyRewardTimer] = useState(
        UIModel?.instance?.showNextRewardLabel ?? false
    );

    const [dailyRewardTimerText, setDailyRewardTimerText, textRef] = useTextState(
        UIModel?.instance?.nextRewardLabel ?? ''
    );

    useEffect(() => {
        const update = (prop: string) => {
            if (prop === 'ShowNextRewardLabel') {
                setShowDailyRewardTimer(UIModel.instance.showNextRewardLabel);
            }
            if (prop === 'NextRewardLabel') {
                setDailyRewardTimerText(UIModel.instance.nextRewardLabel);
            }
        };
        UIModel.instance.propertyChanged.add(update);
        return () => {
            UIModel.instance.propertyChanged.remove(update);
        };
    }, []);

    return [showDailyRewardTimer, dailyRewardTimerText, textRef];
}
